import React from 'react';
import { Box, Typography, Tabs, Tab, useTheme } from '@mui/material';

const AddonManagementLabel = ({ selectedCompany, isSmallScreen, tabValue, setTabValue, getSelectedCompanyLabel }) => {
    const theme = useTheme();

    // Tabs
    const availableTabs = [
        { value: 'global', label: 'Global' },
        { value: 'device', label: 'Device' },
    ];

    // Handle tab change
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Box
            backgroundColor={theme.palette.background.paper}
            borderRadius="15px"
            mt="1rem"
            p="1rem"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexDirection={isSmallScreen ? 'column' : 'row'}
            gap={isSmallScreen ? '1rem' : '0'}
            sx={{
                boxShadow: '8px 8px 20px rgba(0, 0, 0, 0.1)',
            }}
        >
            <Typography
                variant={isSmallScreen ? 'h3' : 'h2'}
                component="div"
                sx={{
                    color: theme.palette.text.white,
                    fontWeight: 'bold',
                    textAlign: 'left',
                    ml: isSmallScreen ? '0.5rem' : '0',
                }}
            >
                {getSelectedCompanyLabel}
            </Typography>

            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                textColor="primary"
                indicatorColor="secondary"
                TabIndicatorProps={{
                    style: {
                        backgroundColor: theme.palette.text.white,
                    },
                }}
            >
                {availableTabs.map((tab) => (
                    <Tab
                        key={tab.value}
                        label={tab.label}
                        value={tab.value}
                        sx={{
                            typography: isSmallScreen ? 'h6' : 'h5',
                            fontWeight: 'bold',
                            color: tabValue === tab.value ? theme.palette.text.white : theme.palette.text.grey,
                            '&.Mui-selected': {
                                color: theme.palette.text.white,
                            },
                            '&:focus': {
                                outline: 'none',
                            },
                        }}
                    />
                ))}
            </Tabs>
        </Box>
    );
};

export default AddonManagementLabel;
